let ROWS_PER_PAGE = 8;

export default ROWS_PER_PAGE;



// WEBPACK FOOTER //
// ./app/models/rowsPerPage.js